import axios from "axios";
import localforage from "localforage";
import { decryptEnv } from "utils/decrypt";

export async function loadConfig(token) {
  const env = {
    API_URL: process.env.REACT_APP_API_URL,
    SUPER_ADMIN: process.env.REACT_APP_SUPER_ADMIN,
    SERVER_IP: process.env.REACT_APP_SERVER_IP,
    CUSTOM_URL: process.env.REACT_APP_CUSTOM_URL,
    ACCOUNT_LEVEL_URL: process.env.REACT_APP_ACCOUNT_LEVEL_URL,
    GDriveURL: process.env.REACT_APP_GDRIVEURL,
    AGENT_BUILDER_URL: process.env.REACT_APP_AGENT_BUILDER_URL,
    GHL: {
      CLIENT_ID: process.env.REACT_APP_GHL_CLIENT_ID,
      CLIENT_SECRET: process.env.REACT_APP_GHL_CLIENT_SECRET,
      SCOPE: process.env.REACT_APP_GHL_SCOPE,
      LOCATION_CLIENT_ID: process.env.REACT_APP_GHL_LOCATION_CLIENT_ID,
      LOCATION_CLIENT_SECRET: process.env.REACT_APP_GHL_LOCATION_CLIENT_SECRET,
      LOCATION_SCOPE: process.env.REACT_APP_GHL_LOCATION_SCOPE,
      ACCOUNT_CLIENT_ID: process.env.REACT_APP_GHL_ACCOUNT_CLIENT_ID,
      ACCOUNT_CLIENT_SECRET: process.env.REACT_APP_GHL_ACCOUNT_CLIENT_SECRET,
      ACCOUNT_SCOPE: process.env.REACT_APP_GHL_ACCOUNT_SCOPE,
      REDIRECT: {
        AGENCY: process.env.REACT_APP_GHL_REDIRECT_AGENCY,
        LOCATION: process.env.REACT_APP_GHL_REDIRECT_LOCATION,
        ACCOUNT: process.env.REACT_APP_GHL_REDIRECT_ACCOUNT,
      },
    },
    APP_URL: process.env.REACT_APP_FRONTEND_URL,
    STRIPE_CLIENT_ID: process.env.REACT_APP_STRIPE_CLIENT_ID,
    REDIRECT_STRIPE: process.env.REACT_APP_REDIRECT_STRIPE
  };

  // The backend now requires auth on this endpoint, so a call with no
  // token (the pre-login boot call in src/index.js) would always 401 -
  // skip the network round-trip entirely and keep the build-time env
  // defaults until the post-login refresh in context/user.js's getUser
  // calls this again with a real token.
  if (!token) {
    return env;
  }

  const user = await localforage.getItem("user");
  try {
    const response = await axios.get(
      `${env.API_URL}/v1/frontend?type=agencyiframe&userId=${user?._id || "user"}`,
      { headers: { "x-auth-token": `Bearer ${token}` } }
    );
    const { envs } = decryptEnv(response?.data?.data, user?._id || "user");

    env.SUPER_ADMIN = envs.REACT_APP_SUPER_ADMIN;
    env.CUSTOM_URL = envs.REACT_APP_CUSTOM_URL;
    env.ACCOUNT_LEVEL_URL = envs.REACT_APP_ACCOUNT_LEVEL_URL;
    env.GDriveURL = envs.REACT_APP_GDRIVEURL;
    env.GHL.CLIENT_ID = envs.REACT_APP_GHL_CLIENT_ID;
    env.GHL.CLIENT_SECRET = envs.REACT_APP_GHL_CLIENT_SECRET;
    env.GHL.SCOPE = envs.REACT_APP_GHL_SCOPE;
    env.GHL.LOCATION_CLIENT_ID = envs.REACT_APP_GHL_LOCATION_CLIENT_ID;
    env.GHL.LOCATION_CLIENT_SECRET = envs.REACT_APP_GHL_LOCATION_CLIENT_SECRET;
    env.GHL.LOCATION_SCOPE = envs.REACT_APP_GHL_LOCATION_SCOPE;
    env.GHL.ACCOUNT_CLIENT_ID = envs.REACT_APP_GHL_ACCOUNT_CLIENT_ID;
    env.GHL.ACCOUNT_CLIENT_SECRET = envs.REACT_APP_GHL_ACCOUNT_CLIENT_SECRET;
    env.GHL.ACCOUNT_SCOPE = envs.REACT_APP_GHL_ACCOUNT_SCOPE;
    env.GHL.REDIRECT.AGENCY = envs.REACT_APP_GHL_REDIRECT_AGENCY;
    env.GHL.REDIRECT.LOCATION = envs.REACT_APP_GHL_REDIRECT_LOCATION;
    env.GHL.REDIRECT.ACCOUNT = envs.REACT_APP_GHL_REDIRECT_ACCOUNT;
    env.STRIPE_CLIENT_ID = envs.REACT_APP_STRIPE_CLIENT_ID;
    env.REDIRECT_STRIPE = envs.REACT_APP_REDIRECT_STRIPE;
    return env
  } catch (err) {
    console.error("Failed to load remote env:", err);
    return env;
  }
}
